import { useContext, useState, useEffect } from "react";
import * as Dati from "src/Dati";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { AlertDialogContext } from "../providers/AlertDialogProvider";

const useInfoSection = (Url: string): Dati.CDatiContesto[] => {
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useState<Dati.CDatiContesto[]>([]);

    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: Url,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIListaContesto) => {
                if (data.Dati) {
                    setData(data.Dati);
                }
            },
            OnErrore: (sender: ChiamaWeb, error: Error) => ShowDialog("ERRORE", error.message, "error")
        };
        new ChiamaWeb().Chiama(Param);
    }, []);

    return Data;
};

export default useInfoSection;



// WEBPACK FOOTER //
// ./src/inar2/hooks/InfoSection.ts